import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'employer-esign',
  templateUrl: './employer-esign.component.html'
})
export class EmployerEsignComponent implements OnInit  {

    queryString !: string;

    constructor(private route: ActivatedRoute, private router: Router){}

    ngOnInit(): void {
    this.queryString = new URLSearchParams( Object.fromEntries(
          Object.entries(this.route.snapshot.queryParams)
            .filter(([key]) => ['userType', 'brand'].includes(key))
        )).toString();
    }
}
